import spot_img from '../img/spot.webp';
import iflix from '../img/iflix.jpg';
import aaron from '../img/aaron.jpg';
import natours from '../img/natours.webp';
import oberlo from '../img/oberlo.webp'
import pc_tech from '../img/pctech.jpg';
import electrum from '../img/electrum.webp';
import iflixV3 from '../img/iflix-v3.jpg';
import businessClass from '../img/businessClass.png';
import RapidX from '../img/rapidx.webp'
import Ecommerce from '../img/ecommerce.webp'


let serverIp = '104.131.1.91';

const data = [
  {
    name: "RapidX",
    image: RapidX,
    onDevelopment: false,
    currentJob: true,
    code: "",
    live: `https://fulcrumgt.com/solutions/solutions-rapidx`,
    description:
      "RAPIDx provides a foundation for the future of legal spend management through a unique network of leading corporate legal departments and global legal service providers that eliminates intermediaries.",
    techs_used: ["NextJS", "MaterialUI", "Sass", "Redux"],
  },
  {
    name: "Business Class",
    image: businessClass,
    onDevelopment: false,
    code: "",
    live: `https://www.americanexpress.com/en-us/business/trends-and-insights/`,
    description:
      "Business Class from American Express provides a modern business education through insights, tips, and inspiration to help your business adapt to changing times.",
    techs_used: [
      "React",
      "Redux",
      "Sass",
      "Webpack",
      "Jest",
      "CI/CD",
      "Docker",
    ],
  },
  {
    name: "Spot",
    image: spot_img,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/Spot",
    live: "https://spot-agency.netlify.app/",
    description:
      "Spot is an Agency website where clients can get information about awesome services of certain company. Attractive and clean design is what makes this website unique to have a great experience.",
    techs_used: ["React", "Sass", "React Router"],
  },
  {
    name: "Ecommerce",
    image: Ecommerce,
    onDevelopment: true,
    code: "https://github.com/Kmonterohenriquez/e-commerce-NextJS",

    live: "https://kevin-ecommerce-nextjs.netlify.app",
    description:
      "Spot is an Agency website where clients can get information about awesome services of certain company. Attractive and clean design is what makes this website unique to have a great experience.",
    techs_used: [
      "NextJS",
      "Tailwind",
      "Redux",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
    ],
  },
  {
    name: "Oberlo",
    image: oberlo,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/housing",

    live: "https://oberlo.netlify.app/",
    description:
      "Whether you’re looking to buy your home locally or expand your real estate globally, commercially, or into the luxury realm -- Oberlo can help. And with franchises and agents available in all 50 states, you’re sure to find one that specializes in your city and specific needs.",
    techs_used: ["React", "Sass", "Grid", "Flex-box"],
  },
  {
    name: "Electrum",
    image: electrum,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/insurance-app",

    live: "https://insurance-demo.netlify.app/",
    description:
      "Evaluate business or individual customers’ needs and financial status and propose protection plans that meet their criteria. Work with clients to deliver risk management strategies that fit their risk profiles.",
    techs_used: ["React", "Sass", "Grid", "Flex-box"],
  },
  {
    name: "Natours",
    image: natours,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/Natours",

    live: "https://gonatours.netlify.com/",
    description:
      "Connect to the world with small group adventure travel. This an informative website about tours with incredible discount on prices. Tour & Experience Incredible Destinations is our main goal to every client we get.",
    techs_used: ["HTML5", "CSS"],
  },
  {
    name: "iFLIX v3",
    image: iflixV3,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/iflix-v3",

    live: `http://${serverIp}:5001/#/`,
    description:
      "This a website which provide information about movies and series where users can watch their favorite movies and series trailers and save them into their favorite tv shows and movies sections.",
    techs_used: ["React", "Redux", "Express", "Node", "Sass", "Webpack"],
  },
  {
    name: "Pc Tech",
    onDevelopment: true,
    image: pc_tech,
    code: "https://github.com/Kmonterohenriquez/PcTech",

    live: `http://${serverIp}:4060/#/`,
    description:
      "Pc Tech is a company specialized in Computer Repairs and Services, We repair out of warranty laptops and Computer. It is a ecommerce website where users can buy most recent tech devices.",
    techs_used: [
      "React",
      "Redux",
      "Express",
      "Node",
      "Sass",
      "PostgreSQL",
      "Massive",
      // 'Bcrypt',
      "Heroku",
      "AWS",
    ],
  },
  {
    id: 8,
    name: "Aaron",
    image: aaron,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/ecommerce-website",

    live: `http://${serverIp}:4010/#/`,
    description:
      "E-commerce website where clients can get sophisticated and the most elegant clothes such as suit, ties, pants and shoes. This was made for men who love to wear and look elegant, simple and attractive to others.",
    techs_used: ["React", "Express", "Node", "Sass", "PostgreSQL"],
  },
  {
    id: 9,
    name: "iFLIX v1",
    image: iflix,
    onDevelopment: false,
    code: "https://github.com/Kmonterohenriquez/Movie-App",

    live: `http://${serverIp}:4000/#/`,
    description:
      "This a website which provide information about movies and series where users can watch their favorite movies and series trailers and save them into their favorite tv shows and movies sections.",
    techs_used: [
      "React",
      "Redux",
      "Express",
      "Node",
      "Sass",
      "PostgreSQL",
      "Massive",
      "Heroku",
      "AWS",
    ],
  },
];

export default data;
